import React from 'react';
import { Icon } from 'ensightful-koala-ui';
import styled, { css } from 'styled-components';

const FilterCheckboxContainer = styled.div`
    width: 20px;
    min-width: 20px;
    height: 20px;
    min-height: 20px;
    border: 1px solid #9e9e9e;
    border-radius: 2px;
    background-color: ${(props) => (props.selected ? '#6347FF' : 'white')};
    display: flex;
    cursor: pointer;

    ${(props) =>
        props.selected &&
        css`
            border-color: #6347ff;
        `}

    ${(props) =>
        props.disabled &&
        css`
            cursor: not-allowed;
            opacity: 0.2;
        `}
`;

const FilterCheckBox = ({ disabled, selected, onChange, ...props }) => {
    const handleClick = () => {
        if (disabled) return;
        onChange(!selected);
    };

    return (
        <FilterCheckboxContainer disabled={disabled} selected={selected} onClick={handleClick} {...props}>
            <Icon kind={'check'} style={{ margin: 'auto' }} />
        </FilterCheckboxContainer>
    );
};

export default FilterCheckBox;
